class PreviewCreator {
    _options = {
        width: 256,
        height: 1536,
        preview: 256,
    };
    _canvas = null;
    _preview = null;

    // 45 deg shift to deal with gaps
    _shift = Math.PI / 4;

    // left, front, right, back faces in yaw gap
    _mapping = [[-135, -45], [-45, 45], [45, 135], [[135, 180], [-180, -135]]];

    constructor() {
        let {width, height, preview} = this._options;

        this._mapping = this._prepareMapping(this._mapping, this._shift);

        this._canvas = document.createElement('canvas');
        this._preview = document.createElement('canvas');

        this._canvas.width = width;
        this._canvas.height = height;

        this._preview.width = preview;
        this._preview.height = preview;
    }

    static normalizeYaw(yaw) {
        let PI2 = Math.PI * 2;
        return ((yaw + PI2 + Math.PI) % PI2) - Math.PI;
    }

    getPreview(src, config) {
        return this._setSourceImage(src)
            .then(() => {
                return this._generatePreview(config);
            })
    }

    _prepareMapping(array, shift = 0) {
        return array.map((elem) => elem.map((angle) => {
            if (typeof angle === 'object') {
                return angle.map((_angle) => _angle * Math.PI / 180 + shift );
            } else {
                return angle * Math.PI / 180 + shift;
            }
        }))
    }

    _setSourceImage(src) {
        const context = this._canvas.getContext('2d');
        const {width, height} = this._canvas;
        const img = new Image();
        img.crossOrigin = 'anonymous';
        context.clearRect(0, 0, width, height);

        img.src = src;

        return new Promise((resolve, reject) => {
            img.onload = () => {
                context.drawImage(img, 0, 0);
                resolve(this._canvas);
            };

            img.onabort = () => reject('Canceled');
        })
    }

    _generatePreview(config) {
        let {yaw} = config;
        let {preview: ps} = this._options;

        let previewContext = this._preview.getContext('2d');

        previewContext.clearRect(0, 0, ps, ps);

        yaw = PreviewCreator.normalizeYaw(yaw * Math.PI / 180) + this._shift;

        let [[si, ss, se], [ei, es, ee]] = this._getCropIndexes(yaw);

        previewContext.drawImage(
            this._canvas,
            ss * ps,
            si * ps,
            Math.abs(ss - se) * ps,
            ps, 0, 0,
            Math.abs(ss - se) * ps, ps)
        ;
        previewContext.drawImage(
            this._canvas,
            es * ps,
            ei * ps,
            Math.abs(es - ee) * ps,
            ps,
            Math.abs(ss - se) * ps,
            0,
            Math.abs(es - ee) * ps, ps
        );

        return this._preview;
    }

    _getCropIndexes(yaw) {
        let cIndex = this._mapping.findIndex(this._findFaceIndex.bind(this, yaw));
        let lastIndex = this._mapping.length - 1;
        let nIndex, cStartOffset, cEndOffset, nStartOffset, nEndOffset, yawOffset;

        if (!~cIndex) return console.error('< yaw > is out of range');

        let gap = this._mapping[cIndex];

        if (gap[0].length) {
            // back face
            let gapIndex = gap.findIndex((_gap) => (_gap[0] <= yaw) && (yaw <= _gap[1]));

            gap = gap[gapIndex];
            yawOffset = (yaw - gap[0]) / (Math.PI / 2);
            yawOffset = gapIndex ? yawOffset + 0.5 : yawOffset;

        } else {
            yawOffset = (yaw - gap[0]) / (Math.PI / 2);
        }
        nIndex = yawOffset > 0.5
            ? cIndex === lastIndex
                ? 0 : cIndex + 1
            : !cIndex
                ? lastIndex : cIndex - 1;

        cStartOffset = yawOffset > 0.5 ? yawOffset - 0.5 : 0;
        cEndOffset = yawOffset > 0.5 ? 1 : 0.5 + yawOffset;
        nStartOffset = !cStartOffset ? 0.5 + yawOffset : 0;
        nEndOffset = cEndOffset === 1 ? yawOffset - 0.5 : 1;

        // todo: review if we can simplify sort operation
        return [[cIndex, cStartOffset, cEndOffset],[nIndex, nStartOffset, nEndOffset]]
            .sort((a,b)=> a[0] === lastIndex && b[0] === 0
                            ? -1
                            : (b[0] === lastIndex) && (a[0] === 0)
                                ? 0
                                : a[0] - b[0]
            );
    }

    _findFaceIndex(yaw, gap) {
        return Array.isArray(gap[1])
            ? gap.some((_gap) => this._findFaceIndex(yaw, _gap))
            : (gap[0] <= yaw) && (yaw <= gap[1]);
    }

    destroy() {

    }
}

export default PreviewCreator;
